(ns app.front.ui.add-widget
  (:require [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.icon-button :as ui-ib]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [core.util.util :as util]))

(defn- add-entity-title [{:keys [icon title]}]
  [:div.flex.flex-row.items-center.mb-8.gap-2
   (when icon
     (cc/icon {:icon icon :description ""}))
   [:div.font-bold.uppercase
    title]])

(def content-border-w-buttons-class
  "border-b border-solid border-ui-gray pb-3")

(defn- common-widget-content [{:keys [color help buttons content loading?]}]
  [:<>
   (when help [ui/help-2 {:color color} help])
   (into [:div (when buttons
                 {:class content-border-w-buttons-class})]
         content)
   (when buttons
     [ui-action-buttons/action-buttons (util/mmap buttons loading?)])])

(defn add-widget
  "For title, `:title` and `:icon`. `:help` is additional text, can contain newlines. `:loading? true` disables buttons and
   shows spinner.

   `:buttons` is a sequence of maps w/ :text :on-click :icon and :disabled? (see `ui-action-buttons/action-buttons`)"
  [{:keys [title help buttons loading? icon data-cy]} & content]
  [:div.bg-ui-blue-10.p-4.rounded-md.border-2.border-ui-blue-100.border-solid.space-y-4.animation-appear-slide-down
   {:data-cy (or data-cy "add-widget")}
   (when title [add-entity-title (util/mmap icon title)])
   [common-widget-content (util/mmap {:color :white} help buttons content loading?)]])

(defn standalone-add-widget
  "Similar to `add-widget`, but is contained in a section (white backgrouund), has implicit close icon and it's hook `:on-close`.
  Can be used directly inside `:div.cloudpermit-page`."
  [{:keys [tr title help buttons loading? icon data-cy on-close]} & content]
  [:section.p-4.rounded-md.border-2.space-y-4.animation-appear-slide-down
   {:data-cy (or data-cy "standalone-add-widget")}
   [:div.flex.flex-row.items-center.justify-between.gap-2
    [:div.flex.flex-row.items-center.gap-2
     (when icon
       (cc/icon {:icon icon :description ""}))
     [:div.font-bold.uppercase
      title]]
    [ui-ib/icon-button
     {:icon        i/remove
      :on-click    on-close
      :description (tr [:close])}]]
   [common-widget-content (util/mmap help buttons content loading?)]])
